export default "__VITE_ASSET__36d6c29d__"